module.exports = __webpack_public_path__ + "img/tracking-phone.688d853f.png";